import { RecipeHeader } from 'common/src/api/models/recipe-header.models';
import { FC } from 'react';
import { CfKebabButton } from '../../../../cf-ui/buttons/CfKebabButton';
import { toggleSecretRecipeRowActions } from './useSecretRecipeRowAction';

export type SecretRecipesRowActionButtonProps = {
  recipeHeader: RecipeHeader;
};

const SecretRecipeRowActionsButton: FC<SecretRecipesRowActionButtonProps> = (
  props: SecretRecipesRowActionButtonProps
): JSX.Element => {
  const handleClick = (e: HTMLButtonElement) => toggleSecretRecipeRowActions(e, props.recipeHeader);

  return <CfKebabButton onClick={handleClick} variant='row' sx={{ mt: { xs: -1, lg: 0 } }} iconSx={{ zIndex: 5 }} />;
};

export default SecretRecipeRowActionsButton;
